(function () {
  const INPUT_SEL = 'input[data-type="checkbox"][id^="checkbox-"]';

  function enhanceChoiceList(root = document) {
    root.querySelectorAll(INPUT_SEL).forEach((input) => {
      const id = input.id;
      if (!id) return;

      const label = root.querySelector(`label[for="${CSS.escape(id)}"]`);
      if (!label) return;

      // Prevent double-enhancing
      if (label.dataset.a11yCheckbox === 'true') return;
      label.dataset.a11yCheckbox = 'true';

      // Make the label keyboard focusable
      label.tabIndex = 0;

      // Give it semantics so SR users hear it properly
      label.setAttribute('role', 'checkbox');
      label.setAttribute('aria-checked', input.checked ? 'true' : 'false');

      const sync = () => {
        label.setAttribute('aria-checked', input.checked ? 'true' : 'false');
      };

      // Clicking label already toggles the input (even if hidden) in most implementations,
      // but we’ll ensure state sync either way.
      label.addEventListener('click', () => {
        // input may toggle async depending on app, so wait a tick
        setTimeout(sync, 0);
      });

      // Keyboard toggle (Space/Enter)
      label.addEventListener('keydown', (e) => {
        if (e.key !== ' ' && e.key !== 'Enter') return;
        e.preventDefault();
        label.click();
      });

      // If the input is still in DOM and can fire change, keep synced
      input.addEventListener?.('change', sync);

      // Initial sync
      sync();
    });
  }

  // Run now + watch for re-renders
  enhanceChoiceList();

  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      for (const n of m.addedNodes || []) {
        if (n.nodeType !== 1) continue;
        if (n.querySelector?.(INPUT_SEL) || n.matches?.(INPUT_SEL)) {
          enhanceChoiceList(n);
        }
      }
    }
  });

  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
